<app-document-templates-nav></app-document-templates-nav>

<div class="capitan-sub-nav-post-content">

  <div class="pt-3" *ngIf="!accountService.getMyAccount().is_organization_admin">
    <h2>You do not have permission to manage document types.</h2>
  </div>

  <div class="pt-3" *ngIf="serverError !== null">
    <h2>Server Error: {{ serverError }}</h2>
  </div>

  <ng-container *ngIf="accountService.getMyAccount().is_organization_admin && (serverError === null)">

    <div class="pt-3 pl-md-4">

      <div class="row">
        <div class="col-sm-7">
          <h2>Document Templates <span *ngIf="loadingDocumentTemplates" class="text-secondary">- Loading...</span></h2>
        </div>

        <div class="col-sm-5">
          <div class="d-flex justify-content-end align-items-start" style="gap: 12px;">
            <select class="form-control w-auto mb-3"
                    [(ngModel)]="selectedStatus"
                    (ngModelChange)="onStatusChange()"
                    [disabled]="loadingDocumentTemplates">
              <option value="active">Status: Active</option>
              <option value="retired">Status: Retired</option>
            </select>
            <button routerLink="/document-templates/add" type="button" class="btn btn-success mb-3">
              Add Document Template
            </button>
          </div>
        </div>
      </div>

      <div class="alert alert-success" role="alert"
           [class.alert-success]="history.state.feedback.status == 'success'"
           [class.alert-info]="history.state.feedback.status == 'info'"
           *ngIf="history && history.state && history.state.feedback">
        {{ history.state.feedback.text }}
      </div>

      <div class="rounded-table-wrapper table-responsive-lg">
        <table class="table table-hover">

          <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">Last Edited</th>
          </tr>
          </thead>

          <tbody *ngIf="resultsPresent()">
          <tr class="cursor-pointer" *ngFor="let documentTemplate of documentTemplateList.results">
            <td routerLink="/document-templates/{{ documentTemplate.id }}">
              {{ documentTemplate.name }}
            </td>
            <td routerLink="/document-templates/{{ documentTemplate.id }}">
              {{ getDocumentTypeDisplay(documentTemplate.document_type) }}
            </td>
            <td routerLink="/document-templates/{{ documentTemplate.id }}">
              {{ documentTemplate.updated_at|date:"medium" }}
            </td>
          </tr>
          </tbody>

          <tbody *ngIf="!resultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingDocumentTemplates ? 'Loading...' : 'No document templates' }}
            </td>
          </tr>
          </tbody>

        </table>
      </div>

    </div>

  </ng-container>

</div>
